"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const formik_1 = require("formik");
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const Yup = tslib_1.__importStar(require("yup"));
const reusables_1 = require("../../../comps/reusables");
const graphql_1 = require("../../../graphql");
const hooks_1 = require("../../../hooks");
const react_2 = require("@osmosys/react");
exports.AddWorkspace = () => {
    const schema = {
        name: Yup.string()
            .min(2, 'Too short')
            .required('Required'),
    };
    const yupSchema = Yup.object().shape(schema);
    const { loadApp } = hooks_1.useOsmosysContext();
    return (react_1.default.createElement(reactstrap_1.Card, { body: true, className: "mb-2" },
        react_1.default.createElement(reusables_1.Form, { mutationProps: {
                mutation: graphql_1.createWorkspace,
                onCompleted: () => {
                    if (loadApp) {
                        loadApp.refetch();
                    }
                },
            }, valuesToVariables: values => {
                return {
                    data: {
                        name: values.name,
                    },
                };
            }, formikProps: {
                initialValues: {
                    name: '',
                },
                validationSchema: yupSchema,
            } }, ({ errors, touched }, mutationResult) => (react_1.default.createElement(reactstrap_1.FormGroup, { className: "mb-0" },
            react_1.default.createElement(reactstrap_1.Label, null, "Workspace name"),
            react_1.default.createElement(reactstrap_1.Input, { tag: formik_1.Field, type: "text", name: "name" }),
            react_1.default.createElement(reactstrap_1.FormText, null, "e.g. Newspaper Inc., Around the Brim Blog"),
            react_1.default.createElement(reactstrap_1.Collapse, { className: "form-error", tag: reactstrap_1.FormText, color: "danger", isOpen: errors.name && !!touched.name }, errors.name),
            react_1.default.createElement("br", null),
            react_1.default.createElement(reusables_1.AjaxButton, { label: "Create workspace", type: "submit", color: "dark", error: mutationResult.error, success: !!mutationResult.data, loading: mutationResult.loading }),
            react_1.default.createElement(react_2.OsmosysErrorAlert, { resource: "Workspace", action: "create", apolloError: mutationResult.error }))))));
};
//# sourceMappingURL=AddWorkspace.js.map